function loadLetter(view) {
    return () => import( /* webpackChunkName: "letters-[request]" */ `../components/Letter/${view}.vue`)
}

const routes = [
    {
        path: '/letter/survey-permission',
        name: 'SurveyPermission',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa','kaprodi','sekprodi','administrator']
        },
        component: loadLetter('SurveyPermission')
    },
    {
        path: '/letter/letter-internship',
        name: 'LetterInternship',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa','kaprodi','sekprodi','administrator']
        },
        component: loadLetter('LetterInternship')
    },
    {
        path: '/letter/thesis-questionnaire',
        name: 'ThesisQuestionnaire',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa','kaprodi','sekprodi','administrator']
        },
        component: loadLetter('ThesisQuestionnaire')
    },
    {
        path: '/letter/internship-statement',
        name: 'InternshipStatement',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa','kaprodi','sekprodi','administrator']
        },
        component: loadLetter('InternshipStatement')
    },
]

export default routes